
    var riot = require('riot')
    //src: starling/src/tags/perspectives-banner-item.html
riot.tag2('perspectives-banner-item',
  '<div riot-style="background-color: {this.getBackgroundColor()}" class="banner-item"> <i class="material-icons" riot-style="color: {this.color}">visibility</i> <span class="perspective-name">{this.getTitle()}</span> <i class="material-icons cancel" onclick="{this.clear}">clear</i> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _perspectivesUi = require('lib/perspectives-ui');

this.getBackgroundColor = function () {
  return (0, _util.shade)(_this.color, 0.8);
};

this.clear = function () {
  _perspectivesUi.pui.unsetActivePerspective(_this);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspectives-banner-item')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspectives-banner-item.html
// module id = 585
// module chunks = 0